import { render, staticRenderFns } from "./LegacyImportModal.vue?vue&type=template&id=76bff8c4&scoped=true&"
import script from "./LegacyImportModal.vue?vue&type=script&lang=js&"
export * from "./LegacyImportModal.vue?vue&type=script&lang=js&"
import style0 from "./LegacyImportModal.vue?vue&type=style&index=0&id=76bff8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bff8c4",
  null
  
)

export default component.exports